// extracted by mini-css-extract-plugin
export default {"academyMenuContainer":"AcademyMenu_academyMenuContainer__Y8K7h","item":"AcademyMenu_item__ixlDY","itemLink":"AcademyMenu_itemLink__H7FVF","menu":"AcademyMenu_menu__puLkE"};